import type { PageSettings } from '@common/types/page-settings.type';

import { createImmerReducer } from 'ngrx-immer/store';
import { on } from '@ngrx/store';

import PageSettingsActions from './page-settings.actions';

export const WEBSITE_PAGE_SETTINGS_FEATURE_KEY = 'page-settings';

export type PageSettingsState = {
    settings: Record<string, PageSettings>;
    error?: string;
};

export const initialPageSettingsState: PageSettingsState = {
    settings: {},
};

export const pageSettingsReducer = createImmerReducer<PageSettingsState>(
    initialPageSettingsState,
    on(PageSettingsActions.loadPageSettingsSuccess, (state: PageSettingsState, { pageId, settings }) => {
        state.settings[pageId.toString()] = settings;
        return state;
    }),
    on(PageSettingsActions.loadPageSettingsFailure, (state: PageSettingsState, { error }) => {
        state.error = error;
        return state;
    }),
    on(PageSettingsActions.updatePageSettingsSuccess, (state: PageSettingsState, { pageId, pageSettings }) => {
        state.settings[pageId.toString()] = pageSettings;
        return state;
    })
);
